import React from 'react'
import InputsSimulator from './InputsSimulator/InputsSimulator'

const SimulatorJobs = () => {
    return (
        <InputsSimulator />
    )
}

export default React.memo( SimulatorJobs )